import React from 'react';
import { AppBar, Toolbar} from '@material-ui/core';
import {  ThemeProvider, makeStyles } from '@material-ui/styles';
import theme from '../theme';
import Navigation from './navigation'

const useStyle = makeStyles(() => ({
   spacing: {
       paddingTop: 10,
       paddingBottom: 20,
       [theme.breakpoints.down('md')]: {
        paddingTop: 15,
        paddingBottom: 10,
         },
   },
   
}));




function Nav() {
  const classes = useStyle();

     return (
    <ThemeProvider theme={theme}>
        <AppBar elevation={0} color="secondary" className={classes.spacing} position="Static">
            <Toolbar>
             <Navigation/>   
          </Toolbar>
        </AppBar>
    </ThemeProvider>
    );
};

export default Nav;